<template>
  <div class="integralList seller-style">
    <h2 class="f18 fb normal gray_2">积分中心</h2>
    <div>
      <div class="box20"></div>
      <div>
        <el-input v-model="search.shopName" placeholder="请输入店铺名称"></el-input>
        <el-button type="primary" class="mar10_l" @click="getMyPointsList(true)">搜索</el-button>
      </div>
      <div class="box20"></div>
      <el-table :data="pointsList" style="width: 100%; min-width: 1000px">
        <el-table-column prop="shopName" label="店铺名称"> </el-table-column>
        <el-table-column prop="pointsName" label="名称"> </el-table-column>
        <el-table-column prop="points" label="数量"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="c_nx_blue cursor" @click="dialogRecord(scope.row)">积分明细</span>
            <span class="c_nx_blue pad5_lr">|</span>
            <span class="c_nx_blue cursor" @click="dialogRule(scope.row)">使用规则</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="box15"></div>
      <div class="t_right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="积分明细" :visible.sync="sourceVisible" width="730px">
      <div>
        <el-table height="240" :data="pointsRecord" style="width: 100%">
          <el-table-column prop="ptTypeName" label="来源/用途"> </el-table-column>
          <el-table-column prop="createDate" label="时间"> </el-table-column>
          <el-table-column prop="usedPoints" label="获得/消耗数量">
            <template slot-scope="scope"> {{ scope.row.type === 1 || scope.row.type === 4 ? "+" : "-" }}{{ scope.row.usedPoints }} </template>
          </el-table-column>
        </el-table>
        <div class="box15"></div>
        <div class="t_right">
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage1"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount1"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="使用规则" :visible.sync="ruleVisible" width="730px">
      <div>
        <el-table height="240" :data="consumeRuleDtlList" style="width: 100%">
          <el-table-column prop="condition" label="使用条件"> </el-table-column>
          <el-table-column prop="detail" label="单笔使用积分"> </el-table-column>
          <el-table-column prop="busName" label="可用商品">
            <template slot-scope="scope">
              {{ scope.row.busName ? scope.row.busName : "全部商品" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      ruleVisible: false,
      consumeRuleDtlList: [],
      sourceVisible: false,
      pointsRecord: [],
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      pointsList: [],
      search: {
        shopName: "",
        pageNum: 1,
        pageSize: 10,
        systemId: 20,
      },
      pageSize1: 10, // 商品列表页分页大小
      currentPage1: 1, // 商品列表页当前分页
      totalCount1: 0, // 商品列表页商品总数
      row: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getMyPointsList();
  },
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getMyPointsRecord();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.getMyPointsRecord();
    },
    dialogRecord(row) {
      this.row = row;
      this.getMyPointsRecord();
      this.sourceVisible = true;
    },
    getMyPointsRecord() {
      const params = {
        shopId: this.row.shopId,
        systemId: this.search.systemId,
        pageNum: this.currentPage1,
        pageSize: this.pageSize1,
      };
      this.$store.dispatch("points/points/getMyPointsRecord", params).then((data) => {
        const newData = data || {};
        this.pointsRecord = newData.list || [];
        this.totalCount1 = newData.total || 0;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMyPointsList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMyPointsList();
    },
    getMyPointsList(isSearch) {
      this.search.pageNum = this.currentPage;
      this.search.pageSize = this.pageSize;
      if (isSearch === true) {
        this.search.pageNum = 1;
      }
      this.$store.dispatch("points/points/getMyPointsList", this.search).then((data) => {
        const newData = data || {};
        this.pointsList = newData.list || [];
        this.totalCount = newData.total || 0;
      });
    },
    dialogRule(row) {
      row.consumeRuleDtlList.forEach((dtl) => {
        this.initRuleDtl(dtl);
      });
      this.consumeRuleDtlList = row.consumeRuleDtlList;
      this.ruleVisible = true;
    },
    initRuleDtl(dtl) {
      let condition = "";
      let detail = dtl.ruleValue;
      if (dtl.busType === 1) {
        if (dtl.ruleType === 1) {
          condition = "";
        }
        if (dtl.ruleType === 2) {
          condition = `每笔订单成功交易${dtl.ruleKey}元`;
        }
        if (dtl.ruleType === 3) {
          condition = "每笔订单交易金额";
          detail = `${detail}%`;
        }
      }
      if (dtl.busType === 2) {
        if (dtl.ruleType === 1) {
          condition = `单件商品成功交易${dtl.ruleKey}件`;
        }
        if (dtl.ruleType === 2) {
          condition = `单件商品每成功交易${dtl.ruleKey}元`;
        }
        if (dtl.ruleType === 3) {
          condition = "单件商品交易金额";
          detail = `${detail}%`;
        }
      }
      this.$set(dtl, "condition", condition);
      this.$set(dtl, "detail", detail);
      this.$set(dtl, "status", dtl.isValid === 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
